import React, { Component } from 'react';
import { connect } from 'react-redux';
import { compose } from 'recompose';
import { Link } from 'react-router-dom';
import Fab from '@material-ui/core/Fab';
import AddIcon from '@material-ui/icons/Add';
import { withStyles } from '@material-ui/core/styles';
import PropTypes from 'prop-types';
import Grid from '@material-ui/core/Grid';
import withAuthorization from '../../hoc/withAuthorization';
import LargePaper from '../../components/Layout/LargePaper';
import stylesDefault from '../../constants/stylesDefault';
import { getRenters } from '../../store/renters/actions';
import RenterBlock from '../../components/Renter/RenterBlock';
import { RENTER_ADD } from '../../constants/routes';
import Loader from '../../components/Layout/Loader';
import { getSites } from '../../store/sites/actions';
import { ROLE_ADMIN } from '../../constants/roles';

const styles = () => ({
  addButton: {
    position: 'fixed',
    display: 'flex',
    justifyContent: 'center',
    bottom: '3vh',
    right: '3vh',
  },
});

export class RentersPage extends Component {
  static propTypes = {
    classes: PropTypes.object.isRequired,
  };

  state = {};

  static getDerivedStateFromProps(props) {
    let newState = null;

    if(props.authUser) {
      if (!props.renters && !props.pendingRenters && props.errorRenters === null) {
        props.getRenters(props.authUser.ma, ROLE_ADMIN);
      }
      if (!props.sites && !props.pendingSites && props.errorSites === null) {
        props.getSites(props.authUser.ma, ROLE_ADMIN);
      }
    }
    return newState;
  }

  render() {
    let body;
    if (this.props.pending) {
      body = <Loader/>;
    } else if (this.props.renters && this.props.sites) {
      body = this.props.renters.map(renter => <RenterBlock
        key={renter.id}
        {...renter}
        sites={this.props.sites.filter(site => site.renter_info_id === renter.id)}
      />);
    }
    return (
      <LargePaper>
        <h1 style={stylesDefault.title}>Loueurs</h1>
        <Grid container spacing={4} justifyContent="space-around">
          {body}
        </Grid>
        <Fab
          className={this.props.classes.addButton}
          color="primary"
          component={Link}
          aria-label="add"
          to={RENTER_ADD}>
          <AddIcon />
        </Fab>
      </LargePaper>
    );
  }
}


const mapStateToProps = state => ({
  authUser: state.users.authUser,
  pending: state.renters.pending || state.sites.pending,
  pendingRenters: state.renters.pending,
  pendingSites: state.sites.pending,
  renters: state.renters.content,
  sites: state.sites.content,
  errorRenters: state.renters.error,
  errorSites: state.sites.error,
});

export default compose(
  withAuthorization(authUser => !!authUser),
  connect(mapStateToProps, { getRenters, getSites }),
  withStyles(styles),
)(RentersPage);



// WEBPACK FOOTER //
// ./src/containers/RentersPage/RentersPage.jsx